import { Box } from '@mui/material';
import { ReactNode } from 'react';
import { useAdvancedSearchTheme } from '@/shared/ui/search/AdvancedSearch/theme/useAdvancedSearchTheme';

interface IProps {
  children: ReactNode;
}

export function SearchContainer({ children }: IProps) {
  const { containerSx } = useAdvancedSearchTheme();

  return (
    <Box className="advanced-search-container" sx={containerSx}>
      {children}
    </Box>
  );
}
